module.exports = __webpack_public_path__ + "static/media/safe_seting.bc6b21ca.svg";